import { type CSSProperties, type ReactNode, useEffect } from "react";

import "./Backdrop.css";

interface Props {
  onClose: () => void;
  children: ReactNode;
  align?: "center" | "top";
}

export function Backdrop({ onClose, children, align = "center" }: Props) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose]);

  const style: CSSProperties = align === "top" ? { alignItems: "flex-start", paddingTop: 96 } : {};

  return (
    <div className="modal-backdrop" onClick={onClose} style={style}>
      <div onClick={(e) => e.stopPropagation()}>{children}</div>
    </div>
  );
}
